import React from 'react';

import { FooterLinkViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { FooterLinkFormValue } from '../types';
import { buildDto } from '../utils/mappers';

import ModalEdition from './ModalEdition';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: FooterLinkFormValue = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: FooterLinkFormValue) =>
      AdminFonctionnelControllerApi.createFooterLinkUsingPOST(buildDto(values)),
  );
  const { validate } = useValidateReferentielForm(
    (field: FooterLinkViolationDtoFormFieldEnum, values: FooterLinkFormValue) =>
      AdminFonctionnelControllerApi.validateCreateFooterLinkFieldUsingPOST(
        field,
        buildDto(values),
      ),
    response => response.footerLinkViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Créer un lien"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
